<script lang="ts">
  import { getContext } from 'svelte'
  import { twMerge } from 'tailwind-merge'
  type TitleType = {
    id?: string
    title?: string
  }
  type DescType = {
    id?: string
    desc?: string
  }

  interface BaseProps {
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    role?: string
    color?: string
    withEvents?: boolean
    onclick?: (event: MouseEvent) => void
    onkeydown?: (event: KeyboardEvent) => void
    onkeyup?: (event: KeyboardEvent) => void
  }

  interface CtxType extends BaseProps {}
  interface Props extends BaseProps {
    title?: TitleType
    desc?: DescType
    ariaLabel?: string
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  }

  const ctx: CtxType = getContext('iconCtx') ?? {}
  const sizes = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8'
  }

  export let size: Props['size'] = ctx.size || 'md'
  export let role: Props['role'] = ctx.role || 'img'
  export let color: Props['color'] = ctx.color || 'currentColor'
  //export let withEvents: Props['withEvents'] = ctx.withEvents || false
  export let title: TitleType = {}
  export let desc: DescType = {}

  let ariaDescribedby = `${title.id || ''} ${desc.id || ''}`
  let hasDescription = false

  $: if (title.id || desc.id) {
    hasDescription = true
  } else {
    hasDescription = false
  }
  export let ariaLabel = 'archive solid'
  export let strokeWidth = 2
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  {...$$restProps}
  class={twMerge('shrink-0', sizes[size ?? 'md'], $$props.class)}
  {role}
  aria-label={ariaLabel}
  aria-describedby={hasDescription ? ariaDescribedby : undefined}
  viewBox="0 0 512 512"
>
  {#if title.id && title.title}
    <title id={title.id}>{title.title}</title>
  {/if}
  {#if desc.id && desc.desc}
    <desc id={desc.id}>{desc.desc}</desc>
  {/if}
  <circle cx="256" cy="256" r="256" style="fill:#2e51a2" />
  <path
    d="M432.49 410.61V590.3l-44.86-.06V479l-43.31 51.29-42.43-52.44-.43 112.75H256V410.65h47l39.79 54.29 43-54.31zm184.06 44.14.53 135.15h-50.45l-.17-61.25h-59.73c1.49 10.65 4.48 27 8.9 38 3.31 8.13 6.36 16 12.44 24.06l-36.37 24c-7.45-13.57-13.27-28.52-18.73-44.42a198.31 198.31 0 0 1-10.82-46.49c-1.81-16-2.07-31.38 2.28-47.19a83.37 83.37 0 0 1 24.77-39.81c6.68-6.25 16-10.67 23.47-14.66s15.85-5.63 23.62-7.66a158 158 0 0 1 25.41-3.9c8.49-.73 23.62-1.41 51-.6l11.63 37.31h-58.78c-12.65.17-18.73 0-28.61 4.46a47.7 47.7 0 0 0-27.26 41l56.81.7.81-38.61h49.26zM701.72 410v141.35L768 552l-9.17 37.87H656.28V409.33z"
    style="fill:#fff"
    transform="translate(-230,-250)"

  />
</svg>
